import { environment } from '../../../environments/environment';

/** Base for the data-builder backend, served via the deliverables proxy. */
export const DATA_BUILDER_PROXY_BASE = `${environment.GO_API_ROOT}/proxy/deliverables`;

/** Full URLs for the data-builder backend endpoints. */
export const DATA_BUILDER_ENDPOINTS = {
  root: `${DATA_BUILDER_PROXY_BASE}/`,
  status: `${DATA_BUILDER_PROXY_BASE}/status`,
  verify: `${DATA_BUILDER_PROXY_BASE}/verify`,
  submit: `${DATA_BUILDER_PROXY_BASE}/submit`,
  estimate: `${DATA_BUILDER_PROXY_BASE}/estimate`,
  cancel: `${DATA_BUILDER_PROXY_BASE}/cancel`,
  getSettings: `${DATA_BUILDER_PROXY_BASE}/get-settings`,
  updateSettings: `${DATA_BUILDER_PROXY_BASE}/update-settings`,
  share: `${DATA_BUILDER_PROXY_BASE}/share`,
  shareRedeem: `${DATA_BUILDER_PROXY_BASE}/share-redeem`,
  listDatasets: `${DATA_BUILDER_PROXY_BASE}/list-datasets`,
  createDataset: `${DATA_BUILDER_PROXY_BASE}/create-dataset`,
  updateDataset: `${DATA_BUILDER_PROXY_BASE}/update-dataset`,
  deleteDataset: `${DATA_BUILDER_PROXY_BASE}/delete-dataset`,
} as const;

/**
 * Append the `?user_id=` query a Revelio admin uses to act on another user
 * (impersonation), the convention the backend supports on /status, /list-datasets, etc.
 */
export const withUserId = (url: string, userId?: string): string =>
  userId ? `${url}?user_id=${encodeURIComponent(userId)}` : url;
